import { render, staticRenderFns } from "./ComponentWrapperWithAddButton.vue?vue&type=template&id=5866429c&"
import script from "./ComponentWrapperWithAddButton.vue?vue&type=script&lang=js&"
export * from "./ComponentWrapperWithAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports